class NavbarItem {
    constructor(itemText, itemLink, itemIcon, rolesRequired, subItems) {
        this.itemText = itemText;
        this.itemLink = itemLink;
        this.itemIcon = itemIcon;
        this.rolesRequired = rolesRequired;
        this.subItems = subItems;
    }
}

export default NavbarItem;


// WEBPACK FOOTER //
// ./client/app/common/navbar/navbarItem.js